import { Resources } from "Translations/Resources";

export const RESOURCES = Resources.Chat.PhoneGate;
export const RESEND_COOLDOWN_SECONDS = 20;
export const RESEND_LINK_DELAY_SECONDS = 5;
export const OTP_CODE_LENGTH = 6;
export const NON_DIGIT_REGEX = /\D/g;
export const WHITESPACE_REGEX = /\s/g;
